import { apiSlice } from "@/shared/api/api-slice"
import type { ResumeSubscriptionResponse } from "@/shared/types/api/business-mode.types"

import { mapBusinessSubscriptionError } from "./error-mapping"

export const resumeSubscriptionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessSubscription", "BusinessUsageStats"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      resumeSubscription: builder.mutation<ResumeSubscriptionResponse, void>({
        query: () => ({
          url: "/api/v1/business/subscriptions/resume",
          method: "POST"
        }),
        transformErrorResponse: mapBusinessSubscriptionError,
        invalidatesTags: result => {
          // Only invalidate tags if resume was successful (not requiring new invoice)
          if (result?.success) {
            return [{ type: "BusinessSubscription" as const }, { type: "BusinessUsageStats" as const }]
          }
          return []
        }
      })
    })
  })

export const { useResumeSubscriptionMutation } = resumeSubscriptionApi
